export default "__VITE_ASSET__9d0b938d__"